import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dashboard from '../../components/Dashboard';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PostList from '../../components/Posts/PostList';
import { push } from 'connected-react-router';
import { getPostList, deletePost } from '../../redux/modules/post/action';

const ROWS_PER_PAGE = 10;
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  button: {
    margin: theme.spacing.unit,
    float: 'left'
  },
  title: {
    margin: theme.spacing.unit,
    float: 'left'
  }
});

class Posts extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    userList: PropTypes.array,
    classes: PropTypes.object
  }

  state = {
    page: 0,
    rowsPerPage: ROWS_PER_PAGE
  };

  async componentDidMount() {
    const { dispatch } = this.props;
    const { page, rowsPerPage } = this.state;
    await dispatch(getPostList(page, rowsPerPage));
  }

  openView = (postId) => {
    const { dispatch } = this.props;
    dispatch(push(`/posts/view-post/${postId}`));
  }

  updatePost = (postId) => {
    const { dispatch } = this.props;
    dispatch(push(`/posts/edit-post/${postId}`));
  }

  removePost = (postId) => {
    const { dispatch } = this.props;
    dispatch(deletePost(postId));
  }

  handleChangePage = (event, page) => {
    const { dispatch } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({ page });
    dispatch(getPostList(page, rowsPerPage));
  };

  handleChangeRowsPerPage = event => {
    const { dispatch } = this.props;
    const { page } = this.state;
    this.setState({ rowsPerPage: event.target.value });
    dispatch(getPostList(page, event.target.value));
  };

  render() {
    const { classes, total, dispatch, postList } = this.props;
    const { rowsPerPage, page } = this.state;

    return (
      <Dashboard>
        <React.Fragment>
          <Typography className={classes.title} variant="h4">Social Posts</Typography>

          <Button
            variant="fab"
            color="primary"
            aria-label="Add"
            className={classes.button}
            mini
            onClick={() => dispatch(push('/posts/new'))}
          >
            <AddIcon />
          </Button>
          <Paper className={classes.root}>

            <PostList
              list={postList}
              openView={this.openView}
              updatePost={this.updatePost}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              page={page}
              totalRecords={total}
              removePost={this.removePost}
              updateRoomerPost={this.updateRoomerPost}
            />
            
          </Paper>
        </React.Fragment>
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    postList: state.post.list.rows,
    total: state.post.list.count
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Posts));